export const findValuesObjByKey = (obj: Record<string, any>, keyToFind: string): any => {
  return Object.entries(obj).reduce(
    (acc, [key, value]) => (key === keyToFind ? acc.concat(value) : typeof value === 'object' ? acc.concat(findValuesObjByKey(value, keyToFind)) : acc),
    [],
  );
};
